import { useState, useEffect } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import { Tab, TabItem } from '../../../components'
import { RequestAccess, UpdateSubscription, UpdateKeyAccount, TransformOrg } from './actions/index'
import { openEditorPopup } from '../../../components/popup/popup_slice'
import {selectUser, selectUserRoles} from '../../auth/services/auth_slice'
import { Dropdown } from "react-bootstrap";
import './index.css'
const REACT_APP_CHANGE_ORG_USERS = process.env.REACT_APP_CHANGE_ORG_USERS || '[]'
const REACT_APP_TRANSFER_ORG_USERS = process.env.REACT_APP_TRANSFER_ORG_USERS || '[]'
export const ShopDetail = () => {
  const dispatch = useDispatch()

  const user = useSelector(selectUser)
  const userId = user?.profile?.sub
  const canFullOrgUpdatePermission = userId 
      && (JSON.parse(REACT_APP_CHANGE_ORG_USERS) as number[]).includes(Number(userId))
  const canFullOrgTransfer = userId
        && (JSON.parse(REACT_APP_TRANSFER_ORG_USERS) as number[]).includes(Number(userId))
  const [canRequestAccess, setCanRequestAccess] = useState(false)
  const [canUpdateKeyAccount, setCanUpdateKeyAccount] = useState(false)
  const openUserAccessPopup = () => {
    dispatch(
      openEditorPopup({
        title: 'Cấp quyền truy cập',
        acceptText: '',
        cancelText: '',
        content: <RequestAccess />,
        closeOnClickOutside: false,
        class_name: 'popup_user_access'
      })
    )
  }

  const openUpdateSubscriptionPopup = () => {
    dispatch(
      openEditorPopup({
        title: 'Cập nhật ShopPlan',
        acceptText: '',
        cancelText: '',
        content: <UpdateSubscription />,
        closeOnClickOutside: false,
        class_name: 'popup_user_access'
      })
    )
  }

  const openUpdateKeyAccountPopup = () => {
      dispatch(
          openEditorPopup({
              title: 'Cập nhật KeyAccount',
              acceptText: '',
              cancelText: '',
              content: <UpdateKeyAccount/>,
              closeOnClickOutside: false,
              class_name: 'popup_user_access'
          })
      )
  }

  const openTransformOrgPopup = () => {
        dispatch(
            openEditorPopup({
                title: 'Chuyển đổi cửa hàng',
                acceptText: '',
                cancelText: '',
                content: <TransformOrg/>,
                closeOnClickOutside: false,
                class_name: 'popup_user_access',
            })
        )
    }

    const userRoles = useSelector(selectUserRoles)
    useEffect(() => {
        setCanRequestAccess(userRoles.some(r => ['inside.admin', 'inside.shop.request_access'].includes(r)))
    }, [userRoles])
    
    useEffect(() => {
        setCanUpdateKeyAccount(userRoles.some(r => ['inside.admin', 'inside.shop.key_account'].includes(r)))
    }, [userRoles])

  return (
    <div className='shop-detail-wrapper'>
      <div className='justify-right'>
        <Dropdown>
          <Dropdown.Toggle variant="primary" id="dropdown-basic">
            Thao tác
          </Dropdown.Toggle>
          <Dropdown.Menu>
            {canRequestAccess && <Dropdown.Item onClick={openUserAccessPopup}>Cấp quyền truy cập</Dropdown.Item>}
            {canUpdateKeyAccount && <Dropdown.Item onClick={openUpdateKeyAccountPopup}>Cập nhật KeyAccount</Dropdown.Item>}
            {canFullOrgUpdatePermission && <Dropdown.Item onClick={openUpdateSubscriptionPopup}>Cập nhật ShopPlan</Dropdown.Item>}
            {canFullOrgTransfer && <Dropdown.Item onClick={openTransformOrgPopup}>Chuyển đổi cửa hàng</Dropdown.Item>}
          </Dropdown.Menu>
        </Dropdown>
      </div>
      <Tab>
        <TabItem path='.' name='Thông tin cửa hàng' />
        <TabItem path='transactions' name='Lịch sử thanh toán' />
        <TabItem path='appinstalls' name='Lịch sử cài ứng dụng' />
        <TabItem path='themeinstalls' name='Lịch sử cài theme' />
      </Tab>
    </div>
  )
}
